module.exports = __webpack_public_path__ + "img/img-core.e71f415e.png";